import { has, get, pick } from 'lodash';

import { loading, success, error } from 'State/actions';
import { MealSummaryFieldEnum as Fields } from 'Common/FieldEnum';

import * as MealSummarySelectors from './selectors';
import * as types from './types';
import { addNewChecks } from '../helpers/helper';

export const writeMealSummary = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_SUMMARY_WRITING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/WriteMealSummary',
        data
      );
      dispatch(
        success(types.MEAL_SUMMARY, {
          summary: response.data.Data,
          openingAmount: data[Fields.OpenAmount],
          closingAmount: data[Fields.CloseAmount],
        })
      );
    } catch (err) {
      if (has(err, 'response.data.Errors')) {
        dispatch(error(types.MEAL_SUMMARY_ERROR, err.response.data.Errors));
      }
    }

    dispatch(loading(types.MEAL_SUMMARY_WRITING, false));
  };
};

export const getSummaryAmount = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_SUMMARY_LOADING_SUMMARY_AMOUNTS, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/GetSummaryAmounts',
        data
      );
      dispatch(success(types.MEAL_SUMMARY_AMOUNTS, response.data.Data));
    } catch (err) {
      if (has(err, 'response.data.Errors')) {
        dispatch(error(types.MEAL_SUMMARY_ERROR, err.response.data.Errors));
      }
    }

    dispatch(loading(types.MEAL_SUMMARY_LOADING_SUMMARY_AMOUNTS, false));
  };
};

export const updateOpeningCashCalc = ({ denominations, checks }) => ({
  type: types.MEAL_SUMMARY_UPDATE_OPENING_CASH_CALC,
  payload: {
    denominations,
    checks,
  },
});

export const updateClosingCashCalc = ({ denominations, checks }) => ({
  type: types.MEAL_SUMMARY_UPDATE_CLOSING_CASH_CALC,
  payload: {
    denominations,
    checks,
  },
});

export const getOpeningChecks = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS, true));
    try {
      const state = getState();
      const openingChecks = MealSummarySelectors.getOpeningChecks(state);
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/GetChecks',
        data
      );
      const checks = get(response, ['data', 'Data', Fields.OpeningChecks], []);

      dispatch(
        success(
          types.MEAL_SUMMARY_OPENING_CHECKS,
          addNewChecks(openingChecks, checks)
        )
      );
    } catch (err) {
      if (has(err, 'response.data.Errors')) {
        dispatch(error(types.MEAL_SUMMARY_ERROR, err.response.data.Errors));
      }
    }

    dispatch(loading(types.MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS, false));
  };
};

export const getClosingChecks = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS, true));
    try {
      const state = getState();
      const closingChecks = MealSummarySelectors.getClosingChecks(state);
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/GetChecks',
        data
      );
      const checks = get(response, ['data', 'Data', Fields.ClosingChecks], []);

      dispatch(
        success(
          types.MEAL_SUMMARY_CLOSING_CHECKS,
          addNewChecks(closingChecks, checks)
        )
      );
    } catch (err) {
      if (has(err, 'response.data.Errors')) {
        dispatch(error(types.MEAL_SUMMARY_ERROR, err.response.data.Errors));
      }
    }

    dispatch(loading(types.MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS, false));
  };
};

export const getUsersAndSummaryAmount = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.MEAL_SUMMARY_FETCHING_USER_AND_SUMMARY_AMOUNT, true)
      );

      const requestData = pick(data, [Fields.PrimarySiteId]);

      let response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/GetSummaryUsers',
        requestData
      );

      dispatch(success(types.MEAL_SUMMARY_GET_USERS, response.data.Data));

      response = await MPWWebApi.postGenericInsertUpdate(
        'Serving/GetSummaryAmounts',
        data
      );

      dispatch(success(types.MEAL_SUMMARY_AMOUNTS, response.data.Data));
    } catch (err) {
      if (has(err, 'response.data.Errors')) {
        dispatch(error(types.MEAL_SUMMARY_ERROR, err.response.data.Errors));
      }
    }
    dispatch(
      loading(types.MEAL_SUMMARY_FETCHING_USER_AND_SUMMARY_AMOUNT, false)
    );
  };
};

export const clearErrors = () => ({
  type: types.MEAL_SUMMARY_CLEAR_ERRORS,
});

export const clearState = () => ({
  type: types.MEAL_SUMMARY_CLEAR_STATE,
});



// WEBPACK FOOTER //
// ./src/pages/mealsummary/state/actions.js